import { atom } from "jotai";

/**
 * État partagé entre `PersonaTraitsPanel` et `CreatorOnboardingWizard`
 * (step persona_traits). Le panel le met à jour à chaque render, le
 * wizard le lit pour piloter le bouton Suivant et auto-commiter les
 * changements pending quand l'user clique dessus.
 *
 *   - `filledLabels` : set des labels dont la valeur effective (pending
 *     OU committée) est non-vide. Permet au wizard de calculer combien
 *     parmi les requis sont déjà remplis, sans attendre que l'user
 *     clique "Save N changes".
 *   - `commitPending` : closure qui PATCH séquentiellement tous les
 *     traits avec pending value, comme le bouton "Save N changes".
 *     Appelée par le wizard avant d'avancer.
 *   - `creatorId` : Convex `_id` du creator courant — sert d'identité
 *     pour que le wizard sache si l'état est bien celui de SON creator.
 */
export interface PersonaTraitsLiveState {
  creatorId: string;
  filledLabels: Set<string>;
  commitPending: () => Promise<void>;
}

export const personaTraitsLiveStateAtom = atom<PersonaTraitsLiveState | null>(
  null,
);
